import { connect } from 'react-redux';
import List from './List';
import timeDepositActions from '../../../../store/actions/timeDeposit.action';
import googleAnalytics from '../../../../store/actions/googleAnalytics.action';

const mapStateToPros = state => ({
  list: state.timeDeposit.list
});

const mapDispatchToProps = dispatch => {
  return {
    listTimeDeposits: () => dispatch(timeDepositActions.listTimeDeposits()),
    googleAnalytics: (params) => {
      googleAnalytics.registerGoogleAnalytics(params);
    }
  };
};

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(List);
